export interface GuestArchiveStatus {
  archived_at: string | null;
  archived_by: number | null;
  reason: string | null;
  reactivated_at: string | null;
  last_activity: string | null;
  inactive: boolean;
  can_archive: boolean;
  blockers: string[];
  remaining_entries: number;
  needs_review: boolean;
  suggestion: boolean;
  explanation: string;
}
export type GuestArchiveView = 'active' | 'archived' | 'suggestions';
export function inArchiveView(archive: GuestArchiveStatus | undefined, view: GuestArchiveView): boolean {
  if (view === 'archived') return !!archive?.archived_at;
  if (view === 'suggestions') return !!archive && !archive.archived_at && archive.inactive;
  return !archive?.archived_at;
}
